import { getSheetIndex } from "../methods/get";
import Store from "../store";

/**
 * 生成随机图表id
 */
function generateRandomKey(prefix) {
	if (prefix == null) {
		prefix = "chart";
	}

	var userAgent = window.navigator.userAgent.replace(/[^a-zA-Z0-9]/g, "").split("");
	var mid = "";
	for (var i = 0; i < 12; i++) {
		mid += userAgent[Math.round(Math.random() * (userAgent.length - 1))];
	}
	var time = new Date().getTime();

	return prefix + "_" + mid + "_" + time;
}
/**
 * 深度克隆数据,包括对象，数组，map
 * @param {*} obj 对象，数组，map
 */
function deepCopy(obj) {
	if (!isObject(obj) && !isMap(obj)) {
		return obj;
	}

	let cloneObj;
	if (isMap(obj)) {
		cloneObj = new Map();
		for (let key of obj.keys()) {
			let value = obj.get(key);
			if (isMap(value) || isObject(value) || Array.isArray(obj)) {
				let copyVal = deepCopy(value);
				cloneObj.set(key, copyVal);
			} else {
				cloneObj.set(key, value);
			}
		}
	} else if (typeof obj === "function") {
		cloneObj = obj;
	} else {
		cloneObj = Array.isArray(obj) ? [] : {};
		if (obj instanceof HTMLElement) {
			cloneObj = obj.cloneNode(true);
		} else {
			for (let key in obj) {
				// if (obj.hasOwnProperty(key)) {
				if (Object.prototype.hasOwnProperty.call(obj, key)) {
					cloneObj[key] = isMap(obj[key]) || isObject(obj[key]) ? deepCopy(obj[key]) : obj[key];
				}
			}
		}
	}
	return cloneObj;
}

/**
 * 判断参数是否是Object类型
 * @param {*} o
 */
function isObject(o) {
	return !isMap(o) && (typeof o === "object" || typeof o === "function") && o !== null;
}

/**
 * 判断参数是否是Map类型
 * @param {*} obj
 */
function isMap(obj) {
	if (obj instanceof Map) {
		return true;
	} else {
		return false;
	}
}

// 替换temp中的${xxx}为指定内容 ,temp:字符串，这里指html代码，dataarry：一个对象{"xxx":"替换的内容"}
// 例：luckysheet.replaceHtml("${image}",{"image":"abc","jskdjslf":"abc"})   ==>  abc
function replaceHtml(temp, dataarry) {
	return temp.replace(/\$\{([\w]+)\}/g, function (s1, s2) {
		var s = dataarry[s2];
		if (typeof s != "undefined") {
			return s;
		} else {
			return s1;
		}
	});
}

function hasChinaword(s) {
	var patrn = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
	if (!patrn.exec(s)) {
		return false;
	} else {
		return true;
	}
}

/**
 * 解析数据单位
 * @param { number | string } data
 */
function parseDataToPX(data) {
	// 1. 如果是数字
	if (typeof data === "number") {
		return data + "px";
	}
	// 2. 如果是字符串，但是没有 px 单位
	if (typeof data === "string" && !data.endsWith("px")) {
		return data + "px";
	}
	// 3. 否则，直接返回
	return data;
}

/**
 * 解析数据单元 - 将单位转成 数值型
 */
function parseDataToNumber(data) {
	// 1. 如果是数字
	if (typeof data === "number") {
		return data;
	}
	// 2. 如果是字符串，但是没有 px 单位
	if (typeof data === "string" && !data.endsWith("px")) {
		return parseFloat(data);
	}
	// 3. 如果是字符串，并且以px 结尾
	if (typeof data === "string" && data.endsWith("px")) {
		return parseFloat(data.substring(0, data.length - 2));
	}
	return data;
}

// 更新Store 的 chart 属性 - 特指 left top width height
function updateStoreChart(sheetIndex, chart_id, left, top, width, height) {
	console.log("图表信息更新", chart_id);
	const chartList = Store.luckysheetfile[getSheetIndex(sheetIndex)].chart;
	chartList.forEach((item) => {
		if (item.chart_id === chart_id) {
			if (left) item.left = left;
			if (top) item.top = top;
			if (width) item.width = width;
			if (height) item.height = height;
		}
	});
}

export { isMap, isObject, deepCopy, generateRandomKey, replaceHtml, parseDataToPX, parseDataToNumber, updateStoreChart };
